"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataGridProTable = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
const _excluded = ["alignItems", "margin", "autoHeight", "checkboxSelection", "columns"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const MemoizedRow = /*#__PURE__*/(0, _react.memo)(_xDataGridPro.GridRow);
const MemoizedCell = /*#__PURE__*/(0, _react.memo)(_xDataGridPro.GridCell);
const MemoizedNoResultsOverlay = /*#__PURE__*/(0, _react.memo)(() => /*#__PURE__*/_react.default.createElement(_material.Stack, {
  height: "100%",
  alignItems: "center",
  justifyContent: "center"
}, "Local filter returns no result"));
const DataGridProTable = props => {
  const {
      alignItems = 'start',
      margin = '5px 33.5px 40px 33.5px',
      autoHeight = true,
      checkboxSelection = false,
      columns
    } = props,
    muiProps = _objectWithoutProperties(props, _excluded);
  const [visibilityModel, setVisibilityModel] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    const getVisibilityModel = () => {
      const model = {};
      columns.map(column => {
        model[column.field] = !column.hide;
        return column;
      });
      if (checkboxSelection) {
        model.checkbox = checkboxSelection;
      }
      return model;
    };
    setVisibilityModel(getVisibilityModel());
  }, [columns, checkboxSelection]);
  return /*#__PURE__*/_react.default.createElement(_xDataGridPro.DataGridPro, _extends({
    getRowHeight: () => 'auto',
    autoHeight: autoHeight,
    disableSelectionOnClick: true,
    hideFooter: true,
    throttleRowsMs: 3000,
    columns: columns,
    columnVisibilityModel: visibilityModel,
    onColumnVisibilityModelChange: newModel => setVisibilityModel(newModel),
    slots: {
      row: MemoizedRow,
      cell: MemoizedCell,
      noResultsOverlay: MemoizedNoResultsOverlay
    },
    sx: {
      color: 'var(--main-color-cl-01)',
      m: margin,
      border: 'none',
      '& .app-header': {
        fontSize: '14px',
        lineHeight: '16px',
        color: 'var(--main-color-cl-01)',
        whiteSpace: 'nowrap',
        outline: 'none'
      },
      '& .app-header:focus': {
        outline: 'none'
      },
      '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold'
      },
      '& .MuiDataGrid-cell': {
        pt: '12px',
        pb: '6px',
        alignItems,
        borderBottom: '1px solid var(--main-color-cl-18)'
      },
      '& .MuiDataGrid-cell:focus': {
        outline: 'none'
      },
      '& .MuiDataGrid-row:hover': {
        backgroundColor: 'var(--main-color-cl-19)'
      },
      '& .MuiDataGrid-row, &:last-child td': {
        borderBottom: '1px solid var(--main-color-cl-18)'
      },
      '& .breakSpacesCell': {
        whiteSpace: 'break-spaces',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      },
      '& .nowrapCell': {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      },
      '& .dateCell': {
        whiteSpace: 'break-spaces !important'
      }
    }
  }, muiProps));
};
exports.DataGridProTable = DataGridProTable;
DataGridProTable.propTypes = {
  alignItems: _propTypes.default.string,
  margin: _propTypes.default.string,
  autoHeight: _propTypes.default.bool,
  checkboxSelection: _propTypes.default.bool,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({}))
};